







 import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
 import {RepositoryFabric} from "../../api/repositories/RepositoryFabric";
 import {ObjectRepository} from "@api/repositories/ObjectRepository";
 import {Element} from "@api/models/Element";
 import DeeplinksMixin from "../../mixins/Deeplinks";

@Component({
     name: 'HtmlPage'
 })
 export default class HtmlPage extends Mixins(DeeplinksMixin) {
     @Prop({required: true}) objectId: string;
     @Prop({required: true}) schemaId: string;

     objectRepository: ObjectRepository = this.$repositories.get(RepositoryFabric.OBJECT);
     page: Element | null = null;

     async mounted() {
         this.getData();
     }

     @Watch("objectId")
     async getData() {
         this.$store.dispatch('showSpinner');

         try {
             this.page = await this.objectRepository.find({
                 schema: this.schemaId,
                 objectId: this.objectId
             });
             this.$store.dispatch('hideSpinner');
             this.$nextTick(() => {
                 this.processDeeplinks(this.$refs['content'] as HTMLElement)
             });
         } catch (e) {
             this.$store.dispatch('reportException', e);
             this.$store.dispatch('hideSpinner');
         }
     }
 }
